import React, { Component } from 'react'

export default class Text extends Component {
    render() {
        return (
            <div className="card bg-dark text-white text-center p-3 randal shadow" >
                <p>{this.props.info.text}</p>
            </div>
        )
    }
}
